module.exports = __webpack_public_path__ + "static/scale-model-of-madame-tussauds-hollywood-in-glendale-california-f5fb13b83407ce913e0db2fe9d328d8f.png";